import { TenantTheme } from '../tenants/';

const showMoreTheme = (theme: TenantTheme) => ({
  color: theme.palette.primary.shade4,
});

export default showMoreTheme;
